<template>
    <div class="hts-form-badges">
        <span
            :class="[classColor, classSize, haveIconClass, flexRowReverseClass]"
            @click="($event) => emits('click', $event)">
            <component
                :is="props.iconName"
                :class="iconPositionClass" />
            <slot />
        </span>
    </div>
</template>

<script setup lang="ts">
const props = defineProps({
  color: {
    // 'active', 'info', 'success', 'error', 'warning', 'disable', 'default'
    type: String,
    default: 'default'
  },
  size: {
    // 'mini', 'small', 'default', 'large', 'x-large'
    type: String,
    default: 'default'
  },
  iconName: {
    // icon name
    type: String,
    default: ''
  },
  iconPosition: {
    // 'left', 'right'
    type: String,
    default: 'left'
  }
})

const sizeDefault = ['mini', 'small', 'default', 'large', 'x-large']
const colorDefault = ['active', 'info', 'success', 'error', 'warning', 'disable', 'default']
const iconPositionDefault = ['left', 'right']

const classColor = computed(() => {
  if ($lodash.includes(colorDefault, props.color)) {
    return `__color-${props.color}`
  }
  return '__color-default'
})

const classSize = computed(() => {
  if ($lodash.includes(sizeDefault, props.size)) {
    return `__size-${props.size}`
  }
  return '__size-default'
})

const haveIconClass = computed(() => {
  if (props.iconName) {
    return '__have-icon'
  }
  return ''
})

const iconPositionClass = computed(() => {
  if ($lodash.includes(iconPositionDefault, props.iconPosition)) {
    return `__icon-position-${props.iconPosition}`
  }
  return '__icon-position-left'
})

const flexRowReverseClass = computed(() => {
  if (props.iconPosition === 'right') {
    return '__flex-row-reverse'
  } else {
    return ''
  }
})

const emits = defineEmits(['click'])
</script>
